import { createSlice } from '@reduxjs/toolkit';
import { Reparation } from '../../types';

interface ReparationsState {
  reparations: Reparation[];
  loading: boolean;
  error: string | null;
}

const initialState: ReparationsState = {
  reparations: [],
  loading: false,
  error: null,
};

const reparationsSlice = createSlice({
  name: 'reparations',
  initialState,
  reducers: {},
});

export default reparationsSlice.reducer;
